// ═══════════════════════════════════════════════════════════════
// Incident Hub — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Group, Button } from '@mantine/core';
import {
  IconShield, IconList, IconTimeline,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/incidents', icon: IconShield, exact: true },
  { label: 'All Incidents', path: '/incidents/list', icon: IconList },
  { label: 'Activity Log', path: '/incidents/activity', icon: IconTimeline, minLevel: 'editor' },
];

export default function IncidentLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const visibleItems = useFilteredNav('incidents', NAV_ITEMS);
  const isDetail = pathname.match(/\/incidents\/\d/);

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <Group gap="xs" mb="md" style={{ borderBottom: '1px solid var(--frost)', paddingBottom: 12 }}>
          {visibleItems.map(item => {
            const active = item.exact ? pathname === item.path : pathname.startsWith(item.path);
            return (
              <Button
                key={item.path}
                variant={active ? 'filled' : 'light'}
                color={active ? brand.blurple : 'gray'}
                size="xs"
                leftSection={<item.icon size={14} />}
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </Button>
            );
          })}
        </Group>
      )}
      <Outlet />
    </div>
  );
}
